import { SympyBuildError, SympyParseError } from "@corca/sympy";
import * as Sentry from "@sentry/nextjs";

export function reportUnexpectedSympyError(error: unknown): void {
  if (error instanceof SympyBuildError || error instanceof SympyParseError) return;
  Sentry.captureException(error);
}

export function trySympy<T extends object>(run: () => T): T | { error: string } {
  try {
    return run();
  } catch (error) {
    reportUnexpectedSympyError(error);
    return { error: error instanceof Error ? error.message : String(error) };
  }
}
